import React from 'react';
import Ui from './Ui';
import './styles.css';

function App() {
  return (
    <div className="app">
    <h1>TYPE&TEST</h1>
      <Ui/>
    </div>
  );
}

export default App;
